import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useRefresh } from '../context/RefreshContext';

export function useEstimates(status = '', startDate = '', endDate = '') {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { refreshCount } = useRefresh();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    const params = {};
    if (status) params.status = status;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    apiClient.get('/estimates', { params })
      .then(res => {
        if (!cancelled) setData(res.data);
      })
      .catch(err => {
        if (!cancelled) setError(err.response?.data?.error || 'Failed to load estimates');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [refreshCount, status, startDate, endDate]);

  return { data, loading, error };
}
